<template>
  <div class="contact-page">
    <div class="page-header">
      <div class="container">
        <el-row>
          <h1 style="width: 100%">联系我们</h1>
        </el-row>
        <el-row>
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>联系我们</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-row>
      </div>
    </div>
    <div class="container">
      <div class="">
        <div class="section-title">
          <h2>联系我们</h2>
          <p>联系我们获取更多信息</p>
        </div>
        <div class="intro-image">
          <img src="/img/dt1.png" alt="技术实力" style="width: 48%; height: 300px; object-fit: cover;">
          <img src="/img/du2.png" alt="技术实力" style="width: 52%; padding-left: 5%; height: 300px; object-fit: cover;">
        </div>
        <div class="contact-info">
          <div class="info-item">
            <img src="/img/bluePhone.svg">
            <div class="info-content">
              <h3>公司地址</h3>
              <p>河南省洛阳市西工区数码大厦</p>
              <p>河南省郑州市金水区瀚海爱特中心</p>
            </div>
          </div>
          <div class="info-item">
            <img src="/img/blueEmail.svg">
            <div class="info-content">
              <h3>联系电话</h3>
              <p>电话：13525947399</p>
            </div>
          </div>
          <div class="info-item">
            <img src="/img/address.svg">
            <div class="info-content">
              <h3>电子邮箱</h3>
              <p>邮箱：hnzlzygczx@163.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br/><br/><br/><br/><br/><br/>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped lang="scss">
.page-header {
  background-image: url('/img/bg2.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
  color: #fff;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h1 {
    margin: 0;
    font-size: 32px;
    font-weight: 500;
    color: #fff;
  }

  .breadcrumb {
    margin-top: 10px;

    .el-breadcrumb {
      font-size: 14px;

      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(255, 255, 255, 0.8);

          &:hover {
            color: #fff;
          }
        }

        &:last-child {
          .el-breadcrumb__inner {
            color: #fff;
          }
        }
      }
    }
  }
}
.contact-info {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  
  .info-item {
    flex: 1;
    min-width: 300px;
    margin: 15px;
    padding: 30px;
    display: flex;
    align-items: flex-start;
    background-color: #f5f5f5;
    border-radius: 4px;
    
    img {
      width: 36px;
      height: 36px;
      color: #1ebec8;
      margin-right: 20px;
    }

    .info-content {
      h3 {
        margin-top: 0;
        margin-bottom: 10px;
        font-size: 18px;
      }
      
      p {
        margin: 0;
        color: #666;
      }
    }
    .intro-image {
      width: 40%;
      padding-right: 30px;

      @media (max-width: 768px) {
        width: 100%;
        padding-right: 0;
        margin-bottom: 20px;
      }

      img {
        width: 100%;
        border-radius: 4px;
      }
    }
  }
}
</style> 